import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-smartphone-line',
    title: '多平台支持',
    description: '哔咔漫画完美适配安卓和iOS设备，同时支持平板电脑，让你随时随地畅享阅读。界面自适应不同屏幕尺寸，操作流畅顺手。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量漫画资源',
    description: '拥有上万部正版漫画作品，涵盖热血、恋爱、奇幻、搞笑、悬疑等多种类型，每日更新热门连载，精彩不容错过。',
  },
  {
    icon: 'ri-moon-line',
    title: '智能阅读模式',
    description: '支持横屏、竖屏自由切换，提供仿真翻页、滑动翻页等多种阅读方式，夜间模式呵护双眼，自动翻页解放双手。',
  },
  {
    icon: 'ri-download-2-line',
    title: '离线下载',
    description: '一键下载漫画到本地，地铁、飞机等无网络环境也能继续阅读。支持批量下载和画质选择，智能管理存储空间。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '智能书签同步',
    description: '自动记录阅读进度，多设备云同步，换设备也能无缝衔接阅读。支持自定义书签和收藏夹分类管理。',
  },
  {
    icon: 'ri-ai-generate',
    title: '个性化推荐',
    description: '基于阅读历史的智能推荐算法，越用越懂你的口味。搭配标签系统和编辑精选，助你发现更多优质漫画。',
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            哔咔漫画功能特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            为二次元爱好者打造的极致漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg p-6 md:p-7 hover:bg-background-50 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-accent-100/70 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-xl text-accent-500`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/gongneng-tese"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-secondary-500 text-background-50 rounded-full font-medium text-sm hover:bg-secondary-600 transition-all duration-300 whitespace-nowrap"
          >
            <span>了解更多功能</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;